namespace GeniuzPOS.Administration {
    export enum PsParaGenTypeEjournalFg {
        EjournalFg0 = 0,
        EjournalFg1 = 1
    }
    Serenity.Decorators.registerEnumType(PsParaGenTypeEjournalFg, 'GeniuzPOS.Administration.PsParaGenTypeEjournalFg', 'Administration.PsParaGenTypeEjournalFg');
}
